module.exports = __webpack_public_path__ + "media/Images/Clouds-d374e4d5.svg";